import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/verify-email";
import AdminLayout from "../layouts/adminLayout";
import Sample from "../pages/Sample";
import Print from "../pages/Print";

import {lazy} from "react";

const Dashboard = lazy(() => import("../pages/Dashboard"));

const UsersList = lazy(() => import("../pages/User/List"));
const UsersServiceManList = lazy(() => import("../pages/User/ListServiceMan"));

const UserNew = lazy(() => import("../pages/User/New"));
//const UploadUserExcelFIle = lazy(() => import("../pages/User/UploadExcel"));
const UserEdit = lazy(() => import("../pages/User/Edit"));
const UserRole = lazy(() => import("../pages/User/UserRole"));
const RoleList = lazy(() => import("../pages/Role/List"));
const RoleNew = lazy(() => import("../pages/Role/New"));
const RoleEdit = lazy(() => import("../pages/Role/Edit"));
const UpdateRolePermission = lazy(() => import("../pages/Role/UpdateRolePermission"));

const PermissionList = lazy(() => import("../pages/Permission/List"))
const PermissionNew = lazy(() => import("../pages/Permission/New"));
const PermissionEdit = lazy(() => import("../pages/Permission/Edit"))

const PermissionCategoryList = lazy(() => import("../pages/PermissionCategory/List"));
const PermissionCategoryNew = lazy(() => import("../pages/PermissionCategory/New"));
const PermissionCategoryEdit = lazy(() => import("../pages/PermissionCategory/Edit"));

const ServiceCategoryList = lazy(() => import("../pages/ServiceCategory/List"));
const ServiceCategoryNew = lazy(() => import("../pages/ServiceCategory/New"));
const ServiceCategoryEdit = lazy(() => import("../pages/ServiceCategory/Edit"));

const ServiceStatusList = lazy(() => import("../pages/ServiceStatus/List"));
const ServiceStatusNew = lazy(() => import("../pages/ServiceStatus/New"));
const ServiceStatusEdit = lazy(() => import("../pages/ServiceStatus/Edit"));

const ServiceTypeList = lazy(() => import("../pages/ServiceType/List"));
const ServiceTypeNew = lazy(() => import("../pages/ServiceType/New"));
const ServiceTypeEdit = lazy(() => import("../pages/ServiceType/Edit"));

const ServiceList = lazy(() => import("../pages/Service/List"));
const ServiceNew = lazy(() => import("../pages/Service/New"));
const ServiceEdit = lazy(() => import("../pages/Service/Edit"));


const ServiceManServiceList = lazy(() => import("../pages/ServiceMan/List"));
const ServiceManServiceEdit = lazy(() => import("../pages/ServiceMan/Edit"));
const ServiceManServiceNew = lazy(() => import("../pages/ServiceMan/New"));

const CityList = lazy(() => import("../pages/City/List"));
const CityNew = lazy(() => import("../pages/City/New"));
const CityEdit = lazy(() => import("../pages/City/Edit"));

const StateList = lazy(() => import("../pages/State/List"));
const StateNew = lazy(() => import("../pages/State/New"));
const StateEdit = lazy(() => import("../pages/State/Edit"));


const CommissionLevelList = lazy(() => import("../pages/CommissionLevel/List"));
const CommissionLevelNew = lazy(() => import("../pages/CommissionLevel/New"));
const CommissionLevelEdit = lazy(() => import("../pages/CommissionLevel/Edit"));

const AssistantServiceList = lazy(() => import("../pages/Assistant/List"));
const AssistantServiceEdit = lazy(() => import("../pages/Assistant/Edit"));

const FrontEnd = lazy(() => import("../pages/FrontEnd"))
const FrontEnd2 = lazy(() => import("../pages/FrontEnd2"))

export const mainRoute = [
    {
        id: 0,
        path: '/*',
        component: AdminLayout,
        isProtected: true
    },
    {
        id: 1,
        title: "ورود",
        path: '/login',
        component: Login,
        isProtected: false
    },
    {
        id: 2,
        title: "ثبت نام",
        path: '/register',
        component: Register,
        isProtected: false
    },
    {
        id: 3,
        title: "فراموشی رمز عبور",
        path: '/forget-password',
        component: ForgetPassword,
        isProtected: false
    },
    {
        id: 4,
        title: "بازنشانی رمز عبور",
        path: '/reset-password',
        component: ResetPassword,
        isProtected: false
    },
    {
        id: 5,
        title: "تایید ایمیل",
        path: '/verify-email',
        component: VerifyEmail,
        isProtected: false
    },
    {
        id: 6,
        title: "تایید ایمیل",
        path: '/sample',
        component: Sample,
        isProtected: false
    },
    {
        id: 7,
        title: "چاپ فاکتور",
        path: '/print',
        component: Print,
        isProtected: false
    },
    {
        id: 8,
        title: "چاپ فاکتور",
        path: '/userRequest',
        component: FrontEnd,
        isProtected: false
    },
    {
        id: 8,
        title: "چاپ فاکتور",
        path: '/userRequest2',
        component: FrontEnd2,
        isProtected: false
    }
]

export const panelRoutes = [
    {
        id: 0,
        title: "داشبورد",
        path: "/dashboard",
        component: Dashboard,
        permission: ""
    },
    {
        id: 1,
        title: "کاربران | لیست",
        path: "/user/list",
        component: UsersList,
        permission: "UserUserList"
    },
    {
        id: 2,
        title: "کاربران | جدید",
        path: "/user/new",
        component: UserNew,
        permission: "UserAddNewUser"
    },
    {
        id: 3,
        title: "کاربران | ویرایش",
        path: "/user/edit/:id",
        component: UserEdit,
        permission: "UserUserItem"
    },
    {
        id: 4,
        title: "کاربران | ویرایش نقش",
        path: "/user/user-role/:id",
        component: UserRole,
        permission: "UserUserItem"
    },
    {
        id: 5,
        title: "نقش ها | لیست",
        path: "/config/role/list",
        component: RoleList,
        permission: "RoleRoleList"
    },
    {
        id: 6,
        title: "نقش ها | جدید",
        path: "/config/role/new",
        component: RoleNew,
        permission: "RoleAddRole"
    },
    {
        id: 7,
        title: "نقش ها | ویرایش",
        path: "/config/role/edit/:id",
        component: RoleEdit,
        permission: "RoleGetRoleItem"
    },
    {
        id: 8,
        title: "سطح دسترسی نقش ها | ویرایش",
        path: "/config/role/update-permission/:id",
        component: UpdateRolePermission,
        permission: "RoleGetRoleItem"
    },
    {
        id: 9,
        title: "سطح دسترسی ها | لیست",
        path: "/config/permission/list",
        component: PermissionList,
        permission: "PermissionPermissionList"
    },
    {
        id: 10,
        title: "سطح دسترسی ها | جدید",
        path: "/config/permission/new",
        component: PermissionNew,
        permission: "PermissionAddPermission"
    },
    {
        id: 11,
        title: "سطح دسترسی ها | ویرایش",
        path: "/config/permission/edit/:id",
        component: PermissionEdit,
        permission: "PermissionGetPermissionItem"
    },
    {
        id: 12,
        title: "دسته بندی سطح دسترسی ها | لیست",
        path: "/config/permission-category/list",
        component: PermissionCategoryList,
        permission: "PermissionCategoryPermissionCategoryList"
    },
    {
        id: 13,
        title: "دسته بندی سطح دسترسی ها | جدید",
        path: "/config/permission-category/new",
        component: PermissionCategoryNew,
        permission: "PermissionCategoryAddPermissionCategory"
    },
    {
        id: 14,
        title: "دسته بندی سطح دسترسی ها | ویرایش",
        path: "/config/permission-category/edit/:id",
        component: PermissionCategoryEdit,
        permission: "PermissionCategoryPermissionCategoryItem"
    },
    {
        id: 15,
        title: "دسته بندی سرویس | لیست",
        path: "/service-category/list",
        component: ServiceCategoryList,
        permission: "ServiceCategoryServiceCategoryList"
    },
    {
        id: 16,
        title: "دسته بندی سرویس | ثبت",
        path: "/service-category/new",
        component: ServiceCategoryNew,
        permission: "ServiceCategoryAddServiceCategory"
    },
    {
        id: 17,
        title: "دسته بندی سرویس | ویرایش",
        path: "/service-category/edit/:id",
        component: ServiceCategoryEdit,
        permission: "ServiceCategoryEditServiceCategory"
    },
    {
        id: 18,
        title: "وضعیت سرویس | لیست",
        path: "/service-status/list",
        component: ServiceStatusList,
        permission: "ServiceStatusServiceStatusList"
    },
    {
        id: 19,
        title: "وضعیت سرویس | ثبت",
        path: "/service-status/new",
        component: ServiceStatusNew,
        permission: "ServiceStatusAddServiceStatus"
    },
    {
        id: 20,
        title: "وضعیت سرویس | ویرایس",
        path: "/service-status/edit/:id",
        component: ServiceStatusEdit,
        permission: "ServiceStatusEditServiceStatus"
    },
    {
        id: 21,
        title: "نوع سرویس | لیست",
        path: "/service-type/list",
        component: ServiceTypeList,
        permission: "ServiceTypeServiceTypeList"
    },
    {
        id: 22,
        title: "نوع سرویس | ثبت",
        path: "/service-type/new",
        component: ServiceTypeNew,
        permission: "ServiceTypeAddServiceType"
    },
    {
        id: 23,
        title: "نوع سرویس | ویرایس",
        path: "/service-type/edit/:id",
        component: ServiceTypeEdit,
        permission: "ServiceTypeEditServiceType"
    },
    {
        id: 24,
        title: "سرویس | لیست",
        path: "/service/list",
        component: ServiceList,
        permission: "ServiceServiceList"
    },
    {
        id: 25,
        title: "سرویس | ثبت",
        path: "/service/new",
        component: ServiceNew,
        permission: "ServiceAddService"
    },
    {
        id: 26,
        title: "سرویس | ویرایس",
        path: "/service/edit/:id",
        component: ServiceEdit,
        permission: "ServiceEditService"
    },
    {
        id: 27,
        title: "سرویس | مشاهده",
        path: "/service-man/edit/:id",
        component: ServiceManServiceEdit,
        permission: "ServiceEditServiceWithServiceMan"
    },
    {
        id: 28,
        title: "سرویس | لیست",
        path: "/service-man/list",
        component: ServiceManServiceList,
        permission: "ServiceServiceManServiceList"
    },
    {
        id: 29,
        title: "شهرها | ویرایش",
        path: "/city/edit/:id",
        component: CityEdit,
        permission: "CityEditCity"
    },
    {
        id: 30,
        title: "شهرها | لیست",
        path: "/city/list",
        component: CityList,
        permission: "CityCityList"
    },
    {
        id: 31,
        title: "شهرها | ثبت",
        path: "/city/new",
        component: CityNew,
        permission: "CityAddCity"
    },
    {
        id: 32,
        title: "استان | ویرایش",
        path: "/state/edit/:id",
        component: StateEdit,
        permission: "StateEditState"
    },
    {
        id: 33,
        title: "استان | لیست",
        path: "/state/list",
        component: StateList,
        permission: "StateStateList"
    },
    {
        id: 34,
        title: "استان | ثبت",
        path: "/state/new",
        component: StateNew,
        permission: "StateAddState"
    },
    {
        id: 35,
        title: "دسته بندی پورسانت | ویرایش",
        path: "/commission-Level/edit/:id",
        component: CommissionLevelEdit,
        permission: "CommissionLevelEditCommissionLevel"
    },
    {
        id: 36,
        title: "دسته بندی پورسانت | لیست",
        path: "/commission-Level/list",
        component: CommissionLevelList,
        permission: "CommissionLevelCommissionLevelList"
    },
    {
        id: 37,
        title: "دسته بندی پورسانت | ثبت",
        path: "/commission-Level/new",
        component: CommissionLevelNew,
        permission: "CommissionLevelAddCommissionLevel"
    },
    {
        id: 38,
        title: "سرویس | مشاهده",
        path: "/assistant/edit/:id",
        component: AssistantServiceEdit,
        permission: "ServiceAssistantServiceList"
    },
    {
        id: 39,
        title: "سرویس | لیست",
        path: "/assistant/list",
        component: AssistantServiceList,
        permission: "ServiceAssistantServiceList"
    },
    {
        id: 40,
        title: "سرویس | ثبت",
        path: "/service-man/new",
        component: ServiceManServiceNew,
        permission: "ServiceAddServiceWithServiceMan"
    },
    {
        id: 41,
        title: "تکنسین ها | لیست",
        path: "/userServiceMan/list",
        component: UsersServiceManList,
        permission: "UserUserList"
    },
]
